<template>
  <section class="section subtle" style="padding-top: 60px">
    <div class="wrap">
      <div class="section-head" style="margin-bottom: 32px">
        <div>
          <div class="eyebrow-line">6 categorías</div>
          <h2 style="font-size: clamp(36px, 5vw, 64px)">ELIGE LA TUYA.</h2>
        </div>
      </div>
      <div class="categories-grid">
        <CategoryCard
          v-for="(cat, i) in cats"
          :key="i"
          :tier="cat.badge"
          :name="cat.name"
          :desc="cat.desc"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import CategoryCard from './ui/CategoryCard.vue'

const cats = [
  { name: 'Masculino Pro',  desc: 'Parejas masculinas · pesos Pro',     badge: 'PRO' },
  { name: 'Femenino Pro',   desc: 'Parejas femeninas · pesos Pro',      badge: 'PRO' },
  { name: 'Mixta Pro',      desc: 'Parejas mixtas · peso masculino',    badge: 'PRO' },
  { name: 'Masculino Open', desc: 'Parejas masculinas · pesos Open',    badge: 'OPEN' },
  { name: 'Femenino Open',  desc: 'Parejas femeninas · pesos Open',     badge: 'OPEN' },
  { name: 'Mixta Open',     desc: 'Parejas mixtas · peso masculino',    badge: 'OPEN' },
]
</script>
